import "./RoomsListing.css";
import React, { Fragment } from "react";
import RoomsListingViewModel from "./RoomsListingViewModel";
import { PulseLoader } from "react-spinners";
import NoDataFound from "../../../../Components/NoDataFound/NoDataFound";
import { Link } from "react-router-dom";

const RoomsListing = () => {
  const { RoomsArray, AuthUser, IsLoading } = RoomsListingViewModel();
  return (
    <Fragment>
      {/* Page Wrapper */}
      <div className="page-wrapper admin-rooms-listing-page">
        <div className="content container-fluid">
          {/* Page Header */}
          <div className="page-header">
            <div className="row align-items-center">
              <div className="col">
                <h3 className="page-title">Hostel</h3>
                <ul className="breadcrumb">
                  <li className="breadcrumb-item">
                    <Link to={`/user/${AuthUser?.UserType}/dashboard`}>
                      Dashboard
                    </Link>
                  </li>
                  <li className="breadcrumb-item active">Hostel</li>
                </ul>
              </div>
            </div>
          </div>
          {/* /Page Header */}
          <div className="row">
            <div className="col-sm-12">
              <div className="card card-table">
                <div className="card-body">
                  {/* Page Header */}
                  <div className="page-header">
                    <div className="row align-items-center">
                      <div className="col">
                        <h3 className="page-title">Hostel</h3>
                      </div>
                    </div>
                  </div>
                  {/* /Page Header */}
                  {IsLoading ? (
                    <PulseLoader
                      style={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                      color="#3D5EE1"
                      size={16}
                    />
                  ) : (
                    <div className="table-responsive">
                      <table className="table border-0 star-student table-hover table-center mb-0 datatable table-striped">
                        <thead className="student-thread">
                          <tr>
                            <th>Hostel Name</th>
                            <th>Block</th>
                            <th>Room No</th>
                            <th>Room Type</th>
                            <th>Total Beds</th>
                            <th>Beds Available</th>
                            <th>Cost Per Bed</th>
                            <th>Availability</th>
                          </tr>
                        </thead>
                        <tbody>
                          {RoomsArray &&
                            RoomsArray.map((item, index) => {
                              const ArrayOfWords = item?.HostelName.split(" ");
                              for (var i = 0; i < ArrayOfWords.length; i++) {
                                ArrayOfWords[i] =
                                  ArrayOfWords[i].charAt(0).toUpperCase() +
                                  ArrayOfWords[i].slice(1);
                              }
                              const StringOfWords = ArrayOfWords.join(" ");
                              return (
                                <tr key={index}>
                                  <td>{StringOfWords}</td>
                                  <td>{item?.Block ? item?.Block : "---"}</td>
                                  <td>{item?.RoomNumber}</td>
                                  <td>{item?.RoomType}</td>
                                  <td>{item?.TotalBeds}</td>
                                  <td>{item?.BedsAvailable}</td>
                                  <td>{item?.CostPerBed}</td>
                                  <td>
                                    {item?.TotalBeds === item?.BedsAvailable ? (
                                      <span className="badge badge-success">
                                        Room Available
                                      </span>
                                    ) : item?.BedsAvailable ? (
                                      <span className="badge badge-warning">
                                        {item?.BedsAvailable} Bed Available
                                      </span>
                                    ) : item?.BedsAvailable === 0 ? (
                                      <span className="badge badge-danger">
                                        Full
                                      </span>
                                    ) : (
                                      ""
                                    )}
                                  </td>
                                </tr>
                              );
                            })}
                        </tbody>
                      </table>
                      {RoomsArray?.length <= 0 && <NoDataFound />}
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      {/* /Page Wrapper */}
    </Fragment>
  );
};

export default RoomsListing;
